"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteLoader = void 0;
const react_1 = require("react");
function useAutocompleteLoader({ source, freeSolo, setPopupOpen, }) {
    const [showLoader, setShowLoader] = react_1.useState(false);
    const loaderRef = react_1.useRef(null);
    react_1.useEffect(() => {
        if (source.loading) {
            // show loader, if data does not come in 500ms
            loaderRef.current = setTimeout(() => {
                setShowLoader(true);
            }, 500);
        }
        else {
            // if freeSolo and source is empty, close popup
            if (freeSolo && source.count === 0) {
                setPopupOpen(false);
            }
            if (loaderRef.current) {
                setShowLoader(false);
                clearTimeout(loaderRef.current);
                loaderRef.current = null;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source.loading]);
    return {
        showLoader,
    };
}
exports.useAutocompleteLoader = useAutocompleteLoader;
//# sourceMappingURL=autocomplete-loader-hook.js.map